import { render, staticRenderFns } from "./FileAddOrUpdate.vue?vue&type=template&id=2077696a&"
import script from "./FileAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./FileAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports